// Slider lifecycle is managed centrally by update-slider.js.

//button-with-underline
if (window.screen.width > 990) {
	let attachedCompare = false;

	// FIX: Added null-check, if .perfect-fit-description doesn't exist on this
	// page, the original code threw a TypeError that silently killed all JS below it.
	let mainProductSection = document.querySelector(".perfect-fit-description");

	if (mainProductSection) {
		let imageContainerMainProduct = mainProductSection.querySelector(
			".button--with-underline--container"
		);

		const followMouseMainProduct = (event) => {
			if (imageContainerMainProduct) {
				imageContainerMainProduct.style.left = event.pageX + "px";
				imageContainerMainProduct.style.top = event.pageY + 30 + "px";
			}
		};

		function showTextMainProduct() {
			if (!attachedCompare && imageContainerMainProduct) {
				attachedCompare = true;
				imageContainerMainProduct.style.display = "block";
				document.addEventListener("pointermove", followMouseMainProduct);
			}
		}

		function hideTextMainProduct() {
			if (imageContainerMainProduct) {
				attachedCompare = false;
				imageContainerMainProduct.style.display = "";
				document.removeEventListener("pointermove", followMouseMainProduct);
			}
		}
	}
}
